// A URL bound for AppSignal, without its query string or fragment: a query string can carry search
// terms, which can be people's names. A URL on another origin keeps the origin, which names the host.
export default function pathOf(url) {
  try {
    const { origin, pathname } = new URL(url, window.location.origin);

    return origin === window.location.origin ? pathname : `${origin}${pathname}`;
  } catch {
    return "";
  }
}
